import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolRobloxCockpitService } from '../../../services/patrol-roblox-cockpit.service';

@Component({
  selector: 'app-patrol-roblox-ingest-panel',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './patrol-roblox-ingest-panel.component.html',
  styleUrl: './patrol-roblox-ingest-panel.component.scss',
})
export class PatrolRobloxIngestPanelComponent {
  #cockpit = inject(PatrolRobloxCockpitService);

  compact = input(false);

  readonly health = this.#cockpit.health;
  readonly ingestReady = this.#cockpit.ingestReady;
  readonly isCheckingHealth = this.#cockpit.isCheckingHealth;
  readonly healthError = this.#cockpit.healthError;

  refresh(): void {
    void this.#cockpit.checkHealth();
  }
}
